"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-showcase" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/bogota_skyline_dusk.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/bogota_skyline_dusk.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/bogota_skyline_dusk.png-wvc-sizes" alt="Cinematic view of Bogotá skyline at dusk" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-foreground/40" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h2 className="font-mono text-primary-foreground text-sm sm:text-base uppercase tracking-widest mb-4 sm:mb-6">
          Experience the Magic
        </h2>

        {}
        <h1 className="font-default text-secondary text-5xl sm:text-6xl md:text-[5rem] leading-tight font-light tracking-wider mb-8 sm:mb-12">
          Bogotá Awaits
        </h1>

        {}
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg shadow-md hover:shadow-lg hover:shadow-primary/20 transition-all duration-300 px-8 py-6 text-lg">
          <Link to="/OurStoryPage">Begin Your Journey</Link>
        </Button>
      </div>
    </section>;
}